import "../styles/globals.css";
import {ThemeProvider, useTheme} from "next-themes";
import Layout from "../components/layout";
import { Provider } from "react-redux";
import { store } from "../redux/store";
import { useRouter } from "next/router";
import { MetaMaskProvider } from "metamask-react";
import Meta from "../components/Meta";
import UserContext from "../components/UserContext";
import {useRef, useEffect, useState} from "react";
import {AuthProvider, hasAuthParams, useAuth} from "react-oidc-context";
import {InMemoryWebStorage, WebStorageStateStore} from "oidc-client-ts";
import SiteConfig from "../siteConfig";
import * as Sentry from "@sentry/react";

if (typeof window !== "undefined") {
  require("bootstrap/dist/js/bootstrap");
}

function MyApp({ Component, pageProps }) {
  Sentry.init({
    dsn: "https://107a95d0e40e001b5aea739863ae8232@o4508611597893632.ingest.de.sentry.io/4508611825762384",
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    environment: SiteConfig.SENTRY_ENVIRONMENT,
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });

  const router = useRouter();
  const pid = router.asPath;
  const scrollRef = useRef({
    scrollPos: 0,
  });
  const currentUrl = typeof window !== "undefined" ? window.location.origin : "";

  const cognitoAuthConfig = {
    authority: SiteConfig.COGNITO_AUTHORITY,
    client_id: SiteConfig.COGNITO_CLIENT_ID,
    redirect_uri: currentUrl, //"http://localhost:3000"
    response_type: "code",
    scope: "openid", //aws.cognito.signin.user.admin email openid phone profile
    automaticSilentRenew: true,
    onSigninCallback: async (user) => {
      if (user) {
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    },
    onSignoutCallback: async() => {
      window.location.href = SiteConfig.COGNITO_LOGOUT_URI;
    }
  };
  
  return (
    <>
      <Meta title="CarbonPump" />

      <Provider store={store}>
        <ThemeProvider enableSystem={true} attribute="class">
          <MetaMaskProvider>
            <AuthProvider 
                {...cognitoAuthConfig}
                userStore={
                  new WebStorageStateStore({
                    store: globalThis?.window?.localStorage ?? InMemoryWebStorage,
                  })
                }>
              <UserContext.Provider value={{ scrollRef: scrollRef }}>
                {pid === "/login" ? (
                  <Component {...pageProps} />
                ) : (
                  <Layout>
                    <Component {...pageProps} />
                  </Layout>
                )}
              </UserContext.Provider>
            </AuthProvider>
          </MetaMaskProvider>
        </ThemeProvider>
      </Provider>
    </>
  );
}

export default MyApp;